module.exports = __webpack_public_path__ + "img/apple-icon.caaa8f06.svg";